window.onload = function() {
    select_defualt_v();
}
    let index = 0;
    var $flkty_carousel_nav = document.querySelector('.product .carousel-nav');
    var $carouselNavCells = $flkty_carousel_nav.querySelectorAll('.carousel-cell');
    let screenSize = window.matchMedia("(max-width: 990px)");

    function iniate_flickity(){
        if(screenSize.matches){
            var $flkty = new Flickity('.product .carousel',{
                prevNextButtons: false,
                pageDots: false,
                fullscreen: false,
                lazyLoad: 0,
                draggable: true,
                passive: false,
                wrapAround: true,
                setGallerySize: true,
                adaptiveHeight: true
            });


            //to provide smooth dragging
            $flkty.on('dragStart', () => (document.ontouchmove = () => false));
            $flkty.on('dragEnd', () => (document.ontouchmove = () => true));
            //to provide smooth dragging
            select_nav_cell($flkty)
        }
    }

    function select_nav_cell($flkty){
       document.querySelectorAll('.product-container .product__media-item--full').forEach(function(item){
            item.style.visibility = 'visible';
            item.style.width = '100%';
       })
       $flkty.resize();
        $carouselNavCells.forEach(carousel_cell => carousel_cell.addEventListener('click', event => {
            $carouselNavCells.forEach(nav_carousel => {
                nav_carousel.classList.remove('is-nav-selected');
            });
            carousel_cell.classList.add('is-nav-selected');
            index = event.currentTarget.getAttribute('data-index');
            $flkty.next();
            $flkty.select(index)
          }));
    }

    function nav_buttonsScroll(){
        let btn_downElem = document.querySelector('.btn-down');
        let btn_upElem = document.querySelector('.btn-up');
        ScrollTop(btn_upElem, btn_downElem);
        ScrollDown(btn_downElem, btn_upElem);
    }

    function ScrollDown(btn_downElem, btn_upElem){
        btn_downElem.addEventListener('click', event => {
            $flkty_carousel_nav.scrollTo({ top: $flkty_carousel_nav.scrollTop + 200, behavior: 'smooth' });
            btn_upElem.disabled = false;
            IsBottom(btn_downElem);
        });
    }

    function ScrollTop(btn_upElem, btn_downElem){
        btn_upElem.addEventListener('click', event => {
            $flkty_carousel_nav.scrollTo({ top: $flkty_carousel_nav.scrollTop - 200, behavior: 'smooth' });
            btn_downElem.disabled = false;
            IsTop(btn_upElem);
        });
    }

    function IsBottom(btn_downElem){
        if(($flkty_carousel_nav.offsetHeight +  $flkty_carousel_nav.scrollTop) + 200 >=  $flkty_carousel_nav.scrollHeight){
            btn_downElem.disabled = true;
        }
    }

    function IsTop(btn_upElem){
        var element = $flkty_carousel_nav.querySelectorAll('.carousel-cell')[0];
        var position = element.getBoundingClientRect();
        //console.log((position.top + 30) + ' B ' + position.bottom + ' < = ' + window.innerHeight)
        if(position.top >= 0 && position.bottom <= window.innerHeight) {
            btn_upElem.disabled = true;
        }
    }

    function select_defualt_v(){
        let select_default_v = document.querySelector('.variant-selected');
        if(select_default_v)
        select_default_v.click();
    }

    iniate_flickity();
    nav_buttonsScroll();

document.addEventListener('DOMContentLoaded', function() {
    const productMediaWrapper = document.querySelector('.product-media__wrapper');
    const showMoreImages = document.querySelector('.show-more-images');
    const showLessImages = document.querySelector('.show-less-images');

    if(showMoreImages && showLessImages && productMediaWrapper){
        const carouselCells = productMediaWrapper.querySelectorAll('.carousel-cell');
        showMoreImages.addEventListener('click', function() {
            carouselCells.forEach(cell => {
                cell.classList.remove('large-up-hide');
            });
            showMoreImages.classList.add('hidden');
            showLessImages.classList.remove('hidden');
        });
        showLessImages.addEventListener('click', function() {
            carouselCells.forEach((cell, index) => {
                if(index > 3){
                    cell.classList.add('large-up-hide');
                }
            });
            showMoreImages.classList.remove('hidden');
            showLessImages.classList.add('hidden');

            // Scroll back up to the top of the product media section
            productMediaWrapper.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    }
});